var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "thumb_down"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_706_302",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 24,
    y: 24,
    width: 24,
    height: 24,
    transform: "rotate(180 24 24)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_706_302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "thumb_down_2",
    d: "M17.4615 19.1924H7.42305V8.19236L13.6923 2.00006L14.1346 2.44236C14.2256 2.53339 14.3022 2.65006 14.3644 2.79236C14.4266 2.93468 14.4577 3.06545 14.4577 3.18468V3.34236L13.4346 8.19236H20.3846C20.8025 8.19236 21.1763 8.35711 21.5058 8.68661C21.8353 9.01609 22 9.38981 22 9.80776V11.0385C22 11.1295 21.9897 11.2289 21.9692 11.3366C21.9487 11.4443 21.9218 11.5436 21.8885 11.6347L19.1577 18.1078C19.0205 18.4155 18.7897 18.6732 18.4654 18.8808C18.141 19.0885 17.8064 19.1924 17.4615 19.1924ZM8.42305 18.1924H17.4615C17.6025 18.1924 17.7468 18.1539 17.8942 18.077C18.0416 18.0001 18.1538 17.8719 18.2308 17.6924L21 11.1924V9.80776C21 9.62827 20.9423 9.48084 20.8269 9.36546C20.7115 9.25007 20.5641 9.19238 20.3846 9.19238H12.1923L13.35 3.73083L8.42305 8.61928V18.1924ZM7.42305 8.19236V9.19238H3.99998V18.1924H7.42305V19.1924H2.99998V8.19236H7.42305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 13",
    d: "M8 8.5L13.5 3L13 8.5C14 8.83333 16.6 9.4 19 9C22 8.5 21.3333 10.5 21 11.5L19.5 15.5C19.5 15.5 18.5 19 16.5 18.5H3.5V8.5H8Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumsUp);
export default __webpack_public_path__ + "static/media/thumsUp.a4cbd9d5102ea6673aff36cc1e81b9b6.svg";
export { ForwardRef as ReactComponent };